import { useMutation } from "@tanstack/react-query";
import { mfaApi } from "./mfa.api";

export const useSendMfaEmailCodeMutation = () => {
  return useMutation({
    mutationFn: () => mfaApi.sendEmailVerificationCode(),
  });
};

export const useConfirmMfaEmailCodeMutation = () => {
  return useMutation({
    mutationFn: (code: string) => mfaApi.confirmEmailVerificationCode(code),
  });
};
